<h3>
  {{ category | titlecase }}
  @if (addCounter) {
    <span>({{ vis.length }})</span>
  }
</h3>
@for (vi of sorted ? vis : (vis | filtViByCategory: category); track vi) {
  <div
    class="vi"
    [ngClass]="{
      undefined: vi.applied.active === null,
      draft: !vi.applied.venue || vi.applied.status === 'DRAFT',
      archived: vi.applied.active === false,
    }"
  >
    <!--     [ngClass]="{'draft': !vi.applied.venue || vi.applied.status === 'DRAFT', 'archived': vi.applied.active === false, 'undefined-draft': vi.applied.status === 'DRAFT' && vi.applied.active === null, 'undefined': vi.applied.active === null}">-->

    <div class="cmp-vi">
      @if (vi.applied.name) {
        <span>{{ vi.applied.name }}</span>
      } @else {
        <span class="noname">Empty name</span>
      }
      <span class="status">
        @if (vi.applied.venue) {
          <div>
            @if (vi.applied.active !== null && vi.applied.active === true) {
              <nz-tag
                [nzColor]="
                  vi.applied.status === 'REJECTED'
                    ? '#f50'
                    : vi.applied.status === 'APPROVED'
                      ? '#87d068'
                      : vi.applied.status === 'DRAFT'
                        ? '#bcbcbd'
                        : 'blue'
                "
              >
                {{ vi.applied.status }}
              </nz-tag>
            } @else {
              @if (vi.applied.active === false) {
                <nz-tag [nzColor]="'gray'"> ARCHIVED </nz-tag>
              }
              @if (vi.applied.active === null) {
                <nz-tag [nzColor]="'gray'"> UNDEFINED </nz-tag>
              }
            }
          </div>
        }
        @if (!vi.applied.venue) {
          <div>
            <nz-tag [nzColor]="'#bcbcbd'">DRAFT</nz-tag>
          </div>
        }
      </span>
    </div>

    <div class="cmp-vi-flags">
      <nz-tag [nzColor]="vi.vendorFlags.noAllotments ? 'volcano' : 'green'">Allotments</nz-tag>
      <nz-tag [nzColor]="vi.vendorFlags.noSchedules ? 'volcano' : 'green'">Schedules</nz-tag>
      <nz-tag [nzColor]="vi.vendorFlags.noRateLevels ? 'volcano' : 'green'">Rate Levels</nz-tag>
    </div>
  </div>
}

@if ((vis | filtViByCategory: category).length === 0) {
  <div class="empty">No Available {{ category }}</div>
}
